/* src/app/account/account-allocations/accounts-receivable-contract-container/accounts-receivable-contract-container.component.scss */
/*# sourceMappingURL=accounts-receivable-contract-container.component.css.map */
